<template>
   <div v-html="this.campaign.html" />
</template>
  
  <script>
  
  import { request } from '@/helpers/services';
  
  export default {
  
    name: 'CampaignTemplate',
    components: {
    },
    data: function () {
      return {
        campaign:{
          html: ""
        },
      }
    },
  
    async mounted(){
      this.$eventHub.$emit('captureMenu', this.topmenu);
      this.uuid = this.$route.params.uuid;
      this.typeOfTemplate = this.$route.query.typeOfTemplate;
      await this.getCampaign();
    },
  
    methods: {
      async getCampaign(){
        try{
          this.$_loadingMixin_showLoading();
          this.campaign.html = await request('campaign-template/'+this.uuid,'get',200);
          this.$_loadingMixin_hideLoading();
        }catch(error){
          console.log(error);
        }
      },
    },
  }
  </script>
  <style>
  .disabled-row {
      pointer-events: none;
      opacity: 0.5;
  }
  </style>
  